export default __webpack_public_path__ + "static/media/test.4a72637f.gif";